import apiHandler from "../core/apiHandler";

/**
 * ✍️ Firma remota para QZ Tray (client → backend)
 */
const qzTrayClientSignerApi = apiHandler("qztray/sign/raw");

export default qzTrayClientSignerApi;
